// @flow
import moment from 'moment';

export type Timer = {
  days: string,
  hours: string,
  minutes: string,
  seconds: string,
};

// rawUtcDate is a string with a format like "2019-01-04T21:19:00Z", and is in UTC time
export function getSecondsUntilDate(rawUtcDate: string): number {
  return Math.round(new Date(rawUtcDate).getTime() / 1000 - Date.now() / 1000);
}

// rawUtcDate is a string with a format like "2019-01-04T21:19:00Z", and is in UTC time
export function getTimeUntilDate(rawUtcDate: string): Timer {
  return breakDownSeconds(getSecondsUntilDate(rawUtcDate));
}

export function getDayFromCampaignEndDate(campaignEndDate: Date): string {
  const date = moment(campaignEndDate).tz('America/Los_Angeles');
  return date.format('MMMM D');
}

export function getDayPlusSevenFromCampaignEndDate(
  campaignEndDate: Date
): string {
  return moment(campaignEndDate)
    .tz('America/Los_Angeles')
    .add(7, 'days')
    .format('MMMM D');
}

export function getAddonsChargeDate(campaignEndDate: Date): string {
  const addonsChargeDate = new Date(campaignEndDate.getTime());
  addonsChargeDate.setDate(addonsChargeDate.getDate() + 2);
  const date = moment(addonsChargeDate).tz('America/Los_Angeles');
  return date.format('MMMM D');
}

export function getEditChargeDate(campaignEndDate: Date): string {
  const editChargeDate = new Date(campaignEndDate.getTime());
  editChargeDate.setDate(editChargeDate.getDate() + 1);
  const date = moment(editChargeDate).tz('America/Los_Angeles');
  return date.format('MMMM D');
}

function insertZero(time: number, threshold: number = 10): string {
  if (time < threshold) {
    return `0${time}`;
  }
  return time.toString();
}

function breakDownSeconds(secs: number): Timer {
  if (secs <= 0) {
    return { days: '0', hours: '0', minutes: '0', seconds: '0' };
  }

  const days = Math.floor(secs / (3600 * 24));
  const hours = Math.floor((secs % (3600 * 24)) / 3600);
  const minutes = Math.floor((secs % 3600) / 60);
  const seconds = Math.floor((secs % 3600) % 60);
  return {
    days: insertZero(days),
    hours: insertZero(hours),
    minutes: insertZero(minutes),
    seconds: insertZero(seconds),
  };
}

const dateFormat = 'MM/DD/YYYY HH:mm:ss';

export const formatDate = (date) => moment(date, dateFormat).toISOString();

export const checkDateIsAfter = (date, dateToCompare) =>
  moment(date, dateFormat).isAfter(moment(dateToCompare, dateFormat));

export const checkIsValid = (date) => moment(date, dateFormat, true).isValid();
